import React, { ComponentProps } from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MunInstallModuleTip } from '../../lib';
import DisplayModuleTip from "../../components/common/m/displayModuleTip";

function RouteMobDisplayModuleTip(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (<>
    <Route weId={`${props.weId || ''}_chelsn`} exact path={`${parentPath}/mobile/uk/displaymoduletip`}>
      {
        <DisplayModuleTip weId={`${props.weId || ''}_lj4rjp`} />
      }
    </Route>
    <Route weId={`${props.weId || ''}_iudo96`} exact path={`${parentPath}/mobile/uk/uninstallmoduletip`}>
      {
        <MunInstallModuleTip weId={`${props.weId || ''}_kia8jg`} />
      }
    </Route>
  </>)
}

export default withRouter(RouteMobDisplayModuleTip);